/**
 * Generated by orval v8.22.0 🍺
 * Do not edit manually.
 * AutoGPT Agent Server
 * This server is used to execute agents that are created by the AutoGPT system.
 * OpenAPI spec version: 0.1
 */
import { useMutation, useQuery } from "@tanstack/react-query";
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult,
} from "@tanstack/react-query";

import type { AutoTopUpConfig } from "../../models/autoTopUpConfig.ts";

import type { GetV1GetCreditHistoryParams } from "../../models/getV1GetCreditHistoryParams.ts";

import type { GetV1GetUserCredits200 } from "../../models/getV1GetUserCredits200.ts";

import type { GetV1ListStripeInvoicesParams } from "../../models/getV1ListStripeInvoicesParams.ts";

import type { GetV1ManagePaymentMethods200 } from "../../models/getV1ManagePaymentMethods200.ts";

import type { HTTP401NotAuthenticatedErrorResponse } from "../../models/hTTP401NotAuthenticatedErrorResponse.ts";

import type { HTTPValidationError } from "../../models/hTTPValidationError.ts";

import type { InvoiceListItem } from "../../models/invoiceListItem.ts";

import type { PostV1RefundCreditTransactionBody } from "../../models/postV1RefundCreditTransactionBody.ts";

import type { RefundRequest } from "../../models/refundRequest.ts";

import type { RequestTopUp } from "../../models/requestTopUp.ts";

import type { SubscriptionStatusResponse } from "../../models/subscriptionStatusResponse.ts";

import type { SubscriptionTierRequest } from "../../models/subscriptionTierRequest.ts";

import type { SubscriptionUpgradePreview } from "../../models/subscriptionUpgradePreview.ts";

import type { SubscriptionUpgradePreviewRequest } from "../../models/subscriptionUpgradePreviewRequest.ts";

import type { TransactionHistory } from "../../models/transactionHistory.ts";

import { customMutator } from "../../../mutators/custom-mutator.ts";

type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];

const withQueryKey = <T extends object, K>(
  query: T,
  queryKey: K,
): T & { queryKey: K } => {
  const result = { queryKey } as T & { queryKey: K };
  for (const key of Object.keys(query)) {
    // The explicit queryKey always wins, matching the previous
    // `{ ...query, queryKey }` spread where it was set last.
    if (key === "queryKey") continue;
    Object.defineProperty(result, key, {
      enumerable: true,
      configurable: true,
      get: () => (query as Record<string, unknown>)[key],
    });
  }
  return result;
};

export type getV1GetUserCreditsResponse200 = {
  data: GetV1GetUserCredits200;
  status: 200;
};

export type getV1GetUserCreditsResponse401 = {
  data: HTTP401NotAuthenticatedErrorResponse;
  status: 401;
};

export type getV1GetUserCreditsResponseSuccess =
  getV1GetUserCreditsResponse200 & {
    headers: Headers;
  };
export type getV1GetUserCreditsResponseError =
  getV1GetUserCreditsResponse401 & {
    headers: Headers;
  };

export type getV1GetUserCreditsResponse =
  | getV1GetUserCreditsResponseSuccess
  | getV1GetUserCreditsResponseError;

export const getGetV1GetUserCreditsUrl = () => {
  return `/api/credits`;
};

/**
 * @summary Get user credits
 */
export const getV1GetUserCredits = async (
  options?: RequestInit,
): Promise<getV1GetUserCreditsResponse> => {
  return customMutator<getV1GetUserCreditsResponse>(
    getGetV1GetUserCreditsUrl(),
    {
      ...options,
      method: "GET",
    },
  );
};

export const getGetV1GetUserCreditsQueryKey = () => {
  return [`/api/credits`] as const;
};

export const getGetV1GetUserCreditsQueryOptions = <
  TData = Awaited<ReturnType<typeof getV1GetUserCredits>>,
  TError = HTTP401NotAuthenticatedErrorResponse,
>(options?: {
  query?: Partial<
    UseQueryOptions<
      Awaited<ReturnType<typeof getV1GetUserCredits>>,
      TError,
      TData
    >
  >;
  request?: SecondParameter<typeof customMutator>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetV1GetUserCreditsQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getV1GetUserCredits>>
  > = ({ signal }) => getV1GetUserCredits({ signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getV1GetUserCredits>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetV1GetUserCreditsQueryResult = NonNullable<
  Awaited<ReturnType<typeof getV1GetUserCredits>>
>;
export type GetV1GetUserCreditsQueryError =
  HTTP401NotAuthenticatedErrorResponse;

export function useGetV1GetUserCredits<
  TData = Awaited<ReturnType<typeof getV1GetUserCredits>>,
  TError = HTTP401NotAuthenticatedErrorResponse,
>(
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getV1GetUserCredits>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getV1GetUserCredits>>,
          TError,
          Awaited<ReturnType<typeof getV1GetUserCredits>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customMutator>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetV1GetUserCredits<
  TData = Awaited<ReturnType<typeof getV1GetUserCredits>>,
  TError = HTTP401NotAuthenticatedErrorResponse,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getV1GetUserCredits>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getV1GetUserCredits>>,
          TError,
          Awaited<ReturnType<typeof getV1GetUserCredits>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customMutator>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetV1GetUserCredits<
  TData = Awaited<ReturnType<typeof getV1GetUserCredits>>,
  TError = HTTP401NotAuthenticatedErrorResponse,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getV1GetUserCredits>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customMutator>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Get user credits
 */

export function useGetV1GetUserCredits<
  TData = Awaited<ReturnType<typeof getV1GetUserCredits>>,
  TError = HTTP401NotAuthenticatedErrorResponse,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getV1GetUserCredits>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customMutator>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetV1GetUserCreditsQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

/**
 * @summary Get user credits
 */
export const prefetchGetV1GetUserCreditsQuery = async <
  TData = Awaited<ReturnType<typeof getV1GetUserCredits>>,
  TError = HTTP401NotAuthenticatedErrorResponse,
>(
  queryClient: QueryClient,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getV1GetUserCredits>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customMutator>;
  },
): Promise<QueryClient> => {
  const queryOptions = getGetV1GetUserCreditsQueryOptions(options);

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
};

export type patchV1FulfillCheckoutSessionResponse200 = {
  data: unknown;
  status: 200;
};

export type patchV1FulfillCheckoutSessionResponse401 = {
  data: HTTP401NotAuthenticatedErrorResponse;
  status: 401;
};

export type patchV1FulfillCheckoutSessionResponseSuccess =
  patchV1FulfillCheckoutSessionResponse200 & {
    headers: Headers;
  };
export type patchV1FulfillCheckoutSessionResponseError =
  patchV1FulfillCheckoutSessionResponse401 & {
    headers: Headers;
  };

export type patchV1FulfillCheckoutSessionResponse =
  | patchV1FulfillCheckoutSessionResponseSuccess
  | patchV1FulfillCheckoutSessionResponseError;

export const getPatchV1FulfillCheckoutSessionUrl = () => {
  return `/api/credits`;
};

/**
 * @summary Fulfill checkout session
 */
export const patchV1FulfillCheckoutSession = async (
  options?: RequestInit,
): Promise<patchV1FulfillCheckoutSessionResponse> => {
  return customMutator<patchV1FulfillCheckoutSessionResponse>(
    getPatchV1FulfillCheckoutSessionUrl(),
    {
      ...options,
      method: "PATCH",
    },
  );
};

export const getPatchV1FulfillCheckoutSessionMutationOptions = <
  TError = HTTP401NotAuthenticatedErrorResponse,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof patchV1FulfillCheckoutSession>>,
    TError,
    void,
    TContext
  >;
  request?: SecondParameter<typeof customMutator>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof patchV1FulfillCheckoutSession>>,
  TError,
  void,
  TContext
> => {
  const mutationKey = ["patchV1FulfillCheckoutSession"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof patchV1FulfillCheckoutSession>>,
    void
  > = () => {
    return patchV1FulfillCheckoutSession(requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PatchV1FulfillCheckoutSessionMutationResult = NonNullable<
  Awaited<ReturnType<typeof patchV1FulfillCheckoutSession>>
>;

export type PatchV1FulfillCheckoutSessionMutationError =
  HTTP401NotAuthenticatedErrorResponse;

/**
 * @summary Fulfill checkout session
 */
export const usePatchV1FulfillCheckoutSession = <
  TError = HTTP401NotAuthenticatedErrorResponse,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof patchV1FulfillCheckoutSession>>,
      TError,
      void,
      TContext
    >;
    request?: SecondParameter<typeof customMutator>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof patchV1FulfillCheckoutSession>>,
  TError,
  void,
  TContext
> => {
  return useMutation(
    getPatchV1FulfillCheckoutSessionMutationOptions(options),
    queryClient,
  );
};
export type postV1RequestCreditTopUpResponse200 = {
  data: unknown;
  status: 200;
};

export type postV1RequestCreditTopUpResponse401 = {
  data: HTTP401NotAuthenticatedErrorResponse;
  status: 401;
};

export type postV1RequestCreditTopUpResponse422 = {
  data: HTTPValidationError;
  status: 422;
};

export type postV1RequestCreditTopUpResponseSuccess =
  postV1RequestCreditTopUpResponse200 & {
    headers: Headers;
  };
export type postV1RequestCreditTopUpResponseError = (
  | postV1RequestCreditTopUpResponse401
  | postV1RequestCreditTopUpResponse422
) & {
  headers: Headers;
};

export type postV1RequestCreditTopUpResponse =
  | postV1RequestCreditTopUpResponseSuccess
  | postV1RequestCreditTopUpResponseError;

export const getPostV1RequestCreditTopUpUrl = () => {
  return `/api/credits`;
};

/**
 * @summary Request credit top up
 */
export const postV1RequestCreditTopUp = async (
  requestTopUp: RequestTopUp,
  options?: RequestInit,
): Promise<postV1RequestCreditTopUpResponse> => {
  return customMutator<postV1RequestCreditTopUpResponse>(
    getPostV1RequestCreditTopUpUrl(),
    {
      ...options,
      method: "POST",
      headers: { "Content-Type": "application/json", ...options?.headers },
      body: JSON.stringify(requestTopUp),
    },
  );
};

export const getPostV1RequestCreditTopUpMutationOptions = <
  TError = HTTP401NotAuthenticatedErrorResponse | HTTPValidationError,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postV1RequestCreditTopUp>>,
    TError,
    { data: RequestTopUp },
    TContext
  >;
  request?: SecondParameter<typeof customMutator>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postV1RequestCreditTopUp>>,
  TError,
  { data: RequestTopUp },
  TContext
> => {
  const mutationKey = ["postV1RequestCreditTopUp"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postV1RequestCreditTopUp>>,
    { data: RequestTopUp }
  > = (props) => {
    const { data } = props ?? {};

    return postV1RequestCreditTopUp(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostV1RequestCreditTopUpMutationResult = NonNullable<
  Awaited<ReturnType<typeof postV1RequestCreditTopUp>>
>;
export type PostV1RequestCreditTopUpMutationBody = RequestTopUp;
export type PostV1RequestCreditTopUpMutationError =
  | HTTP401NotAuthenticatedErrorResponse
  | HTTPValidationError;

/**
 * @summary Request credit top up
 */
export const usePostV1RequestCreditTopUp = <
  TError = HTTP401NotAuthenticatedErrorResponse | HTTPValidationError,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postV1RequestCreditTopUp>>,
      TError,
      { data: RequestTopUp },
      TContext
    >;
    request?: SecondParameter<typeof customMutator>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof postV1RequestCreditTopUp>>,
  TError,
  { data: RequestTopUp },
  TContext
> => {
  return useMutation(
    getPostV1RequestCreditTopUpMutationOptions(options),
    queryClient,
  );
};
export type getV1GetAutoTopUpResponse200 = {
  data: AutoTopUpConfig;
  status: 200;
};

export type getV1GetAutoTopUpResponse401 = {
  data: HTTP401NotAuthenticatedErrorResponse;
  status: 401;
};

export type getV1GetAutoTopUpResponseSuccess = getV1GetAutoTopUpResponse200 & {
  headers: Headers;
};
export type getV1GetAutoTopUpResponseError = getV1GetAutoTopUpResponse401 & {
  headers: Headers;
};

export type getV1GetAutoTopUpResponse =
  | getV1GetAutoTopUpResponseSuccess
  | getV1GetAutoTopUpResponseError;

export const getGetV1GetAutoTopUpUrl = () => {
  return `/api/credits/auto-top-up`;
};

/**
 * @summary Get auto top up
 */
export const getV1GetAutoTopUp = async (
  options?: RequestInit,
): Promise<getV1GetAutoTopUpResponse> => {
  return customMutator<getV1GetAutoTopUpResponse>(getGetV1GetAutoTopUpUrl(), {
    ...options,
    method: "GET",
  });
};

export const getGetV1GetAutoTopUpQueryKey = () => {
  return [`/api/credits/auto-top-up`] as const;
};

export const getGetV1GetAutoTopUpQueryOptions = <
  TData = Awaited<ReturnType<typeof getV1GetAutoTopUp>>,
  TError = HTTP401NotAuthenticatedErrorResponse,
>(options?: {
  query?: Partial<
    UseQueryOptions<
      Awaited<ReturnType<typeof getV1GetAutoTopUp>>,
      TError,
      TData
    >
  >;
  request?: SecondParameter<typeof customMutator>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetV1GetAutoTopUpQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getV1GetAutoTopUp>>
  > = ({ signal }) => getV1GetAutoTopUp({ signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getV1GetAutoTopUp>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetV1GetAutoTopUpQueryResult = NonNullable<
  Awaited<ReturnType<typeof getV1GetAutoTopUp>>
>;
export type GetV1GetAutoTopUpQueryError = HTTP401NotAuthenticatedErrorResponse;

export function useGetV1GetAutoTopUp<
  TData = Awaited<ReturnType<typeof getV1GetAutoTopUp>>,
  TError = HTTP401NotAuthenticatedErrorResponse,
>(
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getV1GetAutoTopUp>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getV1GetAutoTopUp>>,
          TError,
          Awaited<ReturnType<typeof getV1GetAutoTopUp>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customMutator>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetV1GetAutoTopUp<
  TData = Awaited<ReturnType<typeof getV1GetAutoTopUp>>,
  TError = HTTP401NotAuthenticatedErrorResponse,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getV1GetAutoTopUp>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getV1GetAutoTopUp>>,
          TError,
          Awaited<ReturnType<typeof getV1GetAutoTopUp>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customMutator>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetV1GetAutoTopUp<
  TData = Awaited<ReturnType<typeof getV1GetAutoTopUp>>,
  TError = HTTP401NotAuthenticatedErrorResponse,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getV1GetAutoTopUp>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customMutator>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Get auto top up
 */

export function useGetV1GetAutoTopUp<
  TData = Awaited<ReturnType<typeof getV1GetAutoTopUp>>,
  TError = HTTP401NotAuthenticatedErrorResponse,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getV1GetAutoTopUp>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customMutator>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetV1GetAutoTopUpQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

/**
 * @summary Get auto top up
 */
export const prefetchGetV1GetAutoTopUpQuery = async <
  TData = Awaited<ReturnType<typeof getV1GetAutoTopUp>>,
  TError = HTTP401NotAuthenticatedErrorResponse,
>(
  queryClient: QueryClient,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getV1GetAutoTopUp>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customMutator>;
  },
): Promise<QueryClient> => {
  const queryOptions = getGetV1GetAutoTopUpQueryOptions(options);

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
};

export type postV1ConfigureAutoTopUpResponse200 = {
  data: string;
  status: 200;
};

export type postV1ConfigureAutoTopUpResponse401 = {
  data: HTTP401NotAuthenticatedErrorResponse;
  status: 401;
};

export type postV1ConfigureAutoTopUpResponse422 = {
  data: HTTPValidationError;
  status: 422;
};

export type postV1ConfigureAutoTopUpResponseSuccess =
  postV1ConfigureAutoTopUpResponse200 & {
    headers: Headers;
  };
export type postV1ConfigureAutoTopUpResponseError = (
  | postV1ConfigureAutoTopUpResponse401
  | postV1ConfigureAutoTopUpResponse422
) & {
  headers: Headers;
};

export type postV1ConfigureAutoTopUpResponse =
  | postV1ConfigureAutoTopUpResponseSuccess
  | postV1ConfigureAutoTopUpResponseError;

export const getPostV1ConfigureAutoTopUpUrl = () => {
  return `/api/credits/auto-top-up`;
};

/**
 * Configure auto top-up settings and perform an immediate top-up if needed.
 *
 * Raises HTTPException(422) if the request parameters are invalid or if
 * the credit top-up fails.
 * @summary Configure auto top up
 */
export const postV1ConfigureAutoTopUp = async (
  autoTopUpConfig: AutoTopUpConfig,
  options?: RequestInit,
): Promise<postV1ConfigureAutoTopUpResponse> => {
  return customMutator<postV1ConfigureAutoTopUpResponse>(
    getPostV1ConfigureAutoTopUpUrl(),
    {
      ...options,
      method: "POST",
      headers: { "Content-Type": "application/json", ...options?.headers },
      body: JSON.stringify(autoTopUpConfig),
    },
  );
};

export const getPostV1ConfigureAutoTopUpMutationOptions = <
  TError = HTTP401NotAuthenticatedErrorResponse | HTTPValidationError,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postV1ConfigureAutoTopUp>>,
    TError,
    { data: AutoTopUpConfig },
    TContext
  >;
  request?: SecondParameter<typeof customMutator>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postV1ConfigureAutoTopUp>>,
  TError,
  { data: AutoTopUpConfig },
  TContext
> => {
  const mutationKey = ["postV1ConfigureAutoTopUp"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postV1ConfigureAutoTopUp>>,
    { data: AutoTopUpConfig }
  > = (props) => {
    const { data } = props ?? {};

    return postV1ConfigureAutoTopUp(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostV1ConfigureAutoTopUpMutationResult = NonNullable<
  Awaited<ReturnType<typeof postV1ConfigureAutoTopUp>>
>;
export type PostV1ConfigureAutoTopUpMutationBody = AutoTopUpConfig;
export type PostV1ConfigureAutoTopUpMutationError =
  | HTTP401NotAuthenticatedErrorResponse
  | HTTPValidationError;

/**
 * @summary Configure auto top up
 */
export const usePostV1ConfigureAutoTopUp = <
  TError = HTTP401NotAuthenticatedErrorResponse | HTTPValidationError,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postV1ConfigureAutoTopUp>>,
      TError,
      { data: AutoTopUpConfig },
      TContext
    >;
    request?: SecondParameter<typeof customMutator>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof postV1ConfigureAutoTopUp>>,
  TError,
  { data: AutoTopUpConfig },
  TContext
> => {
  return useMutation(
    getPostV1ConfigureAutoTopUpMutationOptions(options),
    queryClient,
  );
};
export type getV1ListStripeInvoicesResponse200 = {
  data: InvoiceListItem[];
  status: 200;
};

export type getV1ListStripeInvoicesResponse401 = {
  data: HTTP401NotAuthenticatedErrorResponse;
  status: 401;
};

export type getV1ListStripeInvoicesResponse422 = {
  data: HTTPValidationError;
  status: 422;
};

export type getV1ListStripeInvoicesResponseSuccess =
  getV1ListStripeInvoicesResponse200 & {
    headers: Headers;
  };
export type getV1ListStripeInvoicesResponseError = (
  | getV1ListStripeInvoicesResponse401
  | getV1ListStripeInvoicesResponse422
) & {
  headers: Headers;
};

export type getV1ListStripeInvoicesResponse =
  | getV1ListStripeInvoicesResponseSuccess
  | getV1ListStripeInvoicesResponseError;

export const getGetV1ListStripeInvoicesUrl = (
  params?: GetV1ListStripeInvoicesParams,
) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? "null" : String(value));
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0
    ? `/api/credits/invoices?${stringifiedParams}`
    : `/api/credits/invoices`;
};

/**
 * Recent Stripe invoices for the caller's active org, for billing managers.
 *
 * The invoices belong to the org the request resolves to (the caller's
 * personal org when no ``X-Org-Id`` is supplied), so this is restricted to
 * org roles holding ``MANAGE_BILLING``.
 *
 * Each item includes ``hosted_invoice_url`` (Stripe-hosted view) and
 * ``invoice_pdf_url`` (direct PDF download). Returns an empty list when
 * the credit system is disabled or the org has no Stripe customer yet.
 * @summary List Stripe invoices
 */
export const getV1ListStripeInvoices = async (
  params?: GetV1ListStripeInvoicesParams,
  options?: RequestInit,
): Promise<getV1ListStripeInvoicesResponse> => {
  return customMutator<getV1ListStripeInvoicesResponse>(
    getGetV1ListStripeInvoicesUrl(params),
    {
      ...options,
      method: "GET",
    },
  );
};

export const getGetV1ListStripeInvoicesQueryKey = (
  params?: GetV1ListStripeInvoicesParams,
) => {
  return [`/api/credits/invoices`, ...(params ? [params] : [])] as const;
};

export const getGetV1ListStripeInvoicesQueryOptions = <
  TData = Awaited<ReturnType<typeof getV1ListStripeInvoices>>,
  TError = HTTP401NotAuthenticatedErrorResponse | HTTPValidationError,
>(
  params?: GetV1ListStripeInvoicesParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getV1ListStripeInvoices>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customMutator>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetV1ListStripeInvoicesQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getV1ListStripeInvoices>>
  > = ({ signal }) =>
    getV1ListStripeInvoices(params, { signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getV1ListStripeInvoices>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetV1ListStripeInvoicesQueryResult = NonNullable<
  Awaited<ReturnType<typeof getV1ListStripeInvoices>>
>;
export type GetV1ListStripeInvoicesQueryError =
  | HTTP401NotAuthenticatedErrorResponse
  | HTTPValidationError;

export function useGetV1ListStripeInvoices<
  TData = Awaited<ReturnType<typeof getV1ListStripeInvoices>>,
  TError = HTTP401NotAuthenticatedErrorResponse | HTTPValidationError,
>(
  params: undefined | GetV1ListStripeInvoicesParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getV1ListStripeInvoices>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getV1ListStripeInvoices>>,
          TError,
          Awaited<ReturnType<typeof getV1ListStripeInvoices>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customMutator>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetV1ListStripeInvoices<
  TData = Awaited<ReturnType<typeof getV1ListStripeInvoices>>,
  TError = HTTP401NotAuthenticatedErrorResponse | HTTPValidationError,
>(
  params?: GetV1ListStripeInvoicesParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getV1ListStripeInvoices>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getV1ListStripeInvoices>>,
          TError,
          Awaited<ReturnType<typeof getV1ListStripeInvoices>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customMutator>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetV1ListStripeInvoices<
  TData = Awaited<ReturnType<typeof getV1ListStripeInvoices>>,
  TError = HTTP401NotAuthenticatedErrorResponse | HTTPValidationError,
>(
  params?: GetV1ListStripeInvoicesParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getV1ListStripeInvoices>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customMutator>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary List Stripe invoices
 */

export function useGetV1ListStripeInvoices<
  TData = Awaited<ReturnType<typeof getV1ListStripeInvoices>>,
  TError = HTTP401NotAuthenticatedErrorResponse | HTTPValidationError,
>(
  params?: GetV1ListStripeInvoicesParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getV1ListStripeInvoices>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customMutator>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetV1ListStripeInvoicesQueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

/**
 * @summary List Stripe invoices
 */
export const prefetchGetV1ListStripeInvoicesQuery = async <
  TData = Awaited<ReturnType<typeof getV1ListStripeInvoices>>,
  TError = HTTP401NotAuthenticatedErrorResponse | HTTPValidationError,
>(
  queryClient: QueryClient,
  params?: GetV1ListStripeInvoicesParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getV1ListStripeInvoices>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customMutator>;
  },
): Promise<QueryClient> => {
  const queryOptions = getGetV1ListStripeInvoicesQueryOptions(params, options);

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
};

export type getV1ManagePaymentMethodsResponse200 = {
  data: GetV1ManagePaymentMethods200;
  status: 200;
};

export type getV1ManagePaymentMethodsResponse401 = {
  data: HTTP401NotAuthenticatedErrorResponse;
  status: 401;
};

export type getV1ManagePaymentMethodsResponseSuccess =
  getV1ManagePaymentMethodsResponse200 & {
    headers: Headers;
  };
export type getV1ManagePaymentMethodsResponseError =
  getV1ManagePaymentMethodsResponse401 & {
    headers: Headers;
  };

export type getV1ManagePaymentMethodsResponse =
  | getV1ManagePaymentMethodsResponseSuccess
  | getV1ManagePaymentMethodsResponseError;

export const getGetV1ManagePaymentMethodsUrl = () => {
  return `/api/credits/manage`;
};

/**
 * Return a Stripe billing-portal URL for the caller.
 *
 * ``url`` is ``None`` when the user has no Stripe customer yet: this route is
 * requested on every Settings > Billing load, so it must never provision a
 * customer as a side effect (see ``create_billing_portal_session``).
 * @summary Manage payment methods
 */
export const getV1ManagePaymentMethods = async (
  options?: RequestInit,
): Promise<getV1ManagePaymentMethodsResponse> => {
  return customMutator<getV1ManagePaymentMethodsResponse>(
    getGetV1ManagePaymentMethodsUrl(),
    {
      ...options,
      method: "GET",
    },
  );
};

export const getGetV1ManagePaymentMethodsQueryKey = () => {
  return [`/api/credits/manage`] as const;
};

export const getGetV1ManagePaymentMethodsQueryOptions = <
  TData = Awaited<ReturnType<typeof getV1ManagePaymentMethods>>,
  TError = HTTP401NotAuthenticatedErrorResponse,
>(options?: {
  query?: Partial<
    UseQueryOptions<
      Awaited<ReturnType<typeof getV1ManagePaymentMethods>>,
      TError,
      TData
    >
  >;
  request?: SecondParameter<typeof customMutator>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetV1ManagePaymentMethodsQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getV1ManagePaymentMethods>>
  > = ({ signal }) => getV1ManagePaymentMethods({ signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getV1ManagePaymentMethods>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetV1ManagePaymentMethodsQueryResult = NonNullable<
  Awaited<ReturnType<typeof getV1ManagePaymentMethods>>
>;
export type GetV1ManagePaymentMethodsQueryError =
  HTTP401NotAuthenticatedErrorResponse;

export function useGetV1ManagePaymentMethods<
  TData = Awaited<ReturnType<typeof getV1ManagePaymentMethods>>,
  TError = HTTP401NotAuthenticatedErrorResponse,
>(
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getV1ManagePaymentMethods>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getV1ManagePaymentMethods>>,
          TError,
          Awaited<ReturnType<typeof getV1ManagePaymentMethods>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customMutator>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetV1ManagePaymentMethods<
  TData = Awaited<ReturnType<typeof getV1ManagePaymentMethods>>,
  TError = HTTP401NotAuthenticatedErrorResponse,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getV1ManagePaymentMethods>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getV1ManagePaymentMethods>>,
          TError,
          Awaited<ReturnType<typeof getV1ManagePaymentMethods>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customMutator>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetV1ManagePaymentMethods<
  TData = Awaited<ReturnType<typeof getV1ManagePaymentMethods>>,
  TError = HTTP401NotAuthenticatedErrorResponse,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getV1ManagePaymentMethods>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customMutator>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Manage payment methods
 */

export function useGetV1ManagePaymentMethods<
  TData = Awaited<ReturnType<typeof getV1ManagePaymentMethods>>,
  TError = HTTP401NotAuthenticatedErrorResponse,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getV1ManagePaymentMethods>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customMutator>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetV1ManagePaymentMethodsQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

/**
 * @summary Manage payment methods
 */
export const prefetchGetV1ManagePaymentMethodsQuery = async <
  TData = Awaited<ReturnType<typeof getV1ManagePaymentMethods>>,
  TError = HTTP401NotAuthenticatedErrorResponse,
>(
  queryClient: QueryClient,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getV1ManagePaymentMethods>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customMutator>;
  },
): Promise<QueryClient> => {
  const queryOptions = getGetV1ManagePaymentMethodsQueryOptions(options);

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
};

export type getV1GetRefundRequestsResponse200 = {
  data: RefundRequest[];
  status: 200;
};

export type getV1GetRefundRequestsResponse401 = {
  data: HTTP401NotAuthenticatedErrorResponse;
  status: 401;
};

export type getV1GetRefundRequestsResponseSuccess =
  getV1GetRefundRequestsResponse200 & {
    headers: Headers;
  };
export type getV1GetRefundRequestsResponseError =
  getV1GetRefundRequestsResponse401 & {
    headers: Headers;
  };

export type getV1GetRefundRequestsResponse =
  | getV1GetRefundRequestsResponseSuccess
  | getV1GetRefundRequestsResponseError;

export const getGetV1GetRefundRequestsUrl = () => {
  return `/api/credits/refunds`;
};

/**
 * @summary Get refund requests
 */
export const getV1GetRefundRequests = async (
  options?: RequestInit,
): Promise<getV1GetRefundRequestsResponse> => {
  return customMutator<getV1GetRefundRequestsResponse>(
    getGetV1GetRefundRequestsUrl(),
    {
      ...options,
      method: "GET",
    },
  );
};

export const getGetV1GetRefundRequestsQueryKey = () => {
  return [`/api/credits/refunds`] as const;
};

export const getGetV1GetRefundRequestsQueryOptions = <
  TData = Awaited<ReturnType<typeof getV1GetRefundRequests>>,
  TError = HTTP401NotAuthenticatedErrorResponse,
>(options?: {
  query?: Partial<
    UseQueryOptions<
      Awaited<ReturnType<typeof getV1GetRefundRequests>>,
      TError,
      TData
    >
  >;
  request?: SecondParameter<typeof customMutator>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetV1GetRefundRequestsQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getV1GetRefundRequests>>
  > = ({ signal }) => getV1GetRefundRequests({ signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getV1GetRefundRequests>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetV1GetRefundRequestsQueryResult = NonNullable<
  Awaited<ReturnType<typeof getV1GetRefundRequests>>
>;
export type GetV1GetRefundRequestsQueryError =
  HTTP401NotAuthenticatedErrorResponse;

export function useGetV1GetRefundRequests<
  TData = Awaited<ReturnType<typeof getV1GetRefundRequests>>,
  TError = HTTP401NotAuthenticatedErrorResponse,
>(
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getV1GetRefundRequests>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getV1GetRefundRequests>>,
          TError,
          Awaited<ReturnType<typeof getV1GetRefundRequests>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customMutator>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetV1GetRefundRequests<
  TData = Awaited<ReturnType<typeof getV1GetRefundRequests>>,
  TError = HTTP401NotAuthenticatedErrorResponse,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getV1GetRefundRequests>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getV1GetRefundRequests>>,
          TError,
          Awaited<ReturnType<typeof getV1GetRefundRequests>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customMutator>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetV1GetRefundRequests<
  TData = Awaited<ReturnType<typeof getV1GetRefundRequests>>,
  TError = HTTP401NotAuthenticatedErrorResponse,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getV1GetRefundRequests>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customMutator>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Get refund requests
 */

export function useGetV1GetRefundRequests<
  TData = Awaited<ReturnType<typeof getV1GetRefundRequests>>,
  TError = HTTP401NotAuthenticatedErrorResponse,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getV1GetRefundRequests>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customMutator>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetV1GetRefundRequestsQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

/**
 * @summary Get refund requests
 */
export const prefetchGetV1GetRefundRequestsQuery = async <
  TData = Awaited<ReturnType<typeof getV1GetRefundRequests>>,
  TError = HTTP401NotAuthenticatedErrorResponse,
>(
  queryClient: QueryClient,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getV1GetRefundRequests>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customMutator>;
  },
): Promise<QueryClient> => {
  const queryOptions = getGetV1GetRefundRequestsQueryOptions(options);

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
};

export type postV1HandleStripeWebhooksResponse200 = {
  data: unknown;
  status: 200;
};

export type postV1HandleStripeWebhooksResponseSuccess =
  postV1HandleStripeWebhooksResponse200 & {
    headers: Headers;
  };
export type postV1HandleStripeWebhooksResponse =
  postV1HandleStripeWebhooksResponseSuccess;

export const getPostV1HandleStripeWebhooksUrl = () => {
  return `/api/credits/stripe_webhook`;
};

/**
 * @summary Handle Stripe webhooks
 */
export const postV1HandleStripeWebhooks = async (
  options?: RequestInit,
): Promise<postV1HandleStripeWebhooksResponse> => {
  return customMutator<postV1HandleStripeWebhooksResponse>(
    getPostV1HandleStripeWebhooksUrl(),
    {
      ...options,
      method: "POST",
    },
  );
};

export const getPostV1HandleStripeWebhooksMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postV1HandleStripeWebhooks>>,
    TError,
    void,
    TContext
  >;
  request?: SecondParameter<typeof customMutator>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postV1HandleStripeWebhooks>>,
  TError,
  void,
  TContext
> => {
  const mutationKey = ["postV1HandleStripeWebhooks"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postV1HandleStripeWebhooks>>,
    void
  > = () => {
    return postV1HandleStripeWebhooks(requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostV1HandleStripeWebhooksMutationResult = NonNullable<
  Awaited<ReturnType<typeof postV1HandleStripeWebhooks>>
>;

export type PostV1HandleStripeWebhooksMutationError = unknown;

/**
 * @summary Handle Stripe webhooks
 */
export const usePostV1HandleStripeWebhooks = <
  TError = unknown,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postV1HandleStripeWebhooks>>,
      TError,
      void,
      TContext
    >;
    request?: SecondParameter<typeof customMutator>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof postV1HandleStripeWebhooks>>,
  TError,
  void,
  TContext
> => {
  return useMutation(
    getPostV1HandleStripeWebhooksMutationOptions(options),
    queryClient,
  );
};
export type getSubscriptionStatusResponse200 = {
  data: SubscriptionStatusResponse;
  status: 200;
};

export type getSubscriptionStatusResponse401 = {
  data: HTTP401NotAuthenticatedErrorResponse;
  status: 401;
};

export type getSubscriptionStatusResponse429 = {
  data: void;
  status: 429;
};

export type getSubscriptionStatusResponseSuccess =
  getSubscriptionStatusResponse200 & {
    headers: Headers;
  };
export type getSubscriptionStatusResponseError = (
  | getSubscriptionStatusResponse401
  | getSubscriptionStatusResponse429
) & {
  headers: Headers;
};

export type getSubscriptionStatusResponse =
  | getSubscriptionStatusResponseSuccess
  | getSubscriptionStatusResponseError;

export const getGetSubscriptionStatusUrl = () => {
  return `/api/credits/subscription`;
};

/**
 * @summary Get subscription tier, current cost, and all tier costs
 */
export const getSubscriptionStatus = async (
  options?: RequestInit,
): Promise<getSubscriptionStatusResponse> => {
  return customMutator<getSubscriptionStatusResponse>(
    getGetSubscriptionStatusUrl(),
    {
      ...options,
      method: "GET",
    },
  );
};

export const getGetSubscriptionStatusQueryKey = () => {
  return [`/api/credits/subscription`] as const;
};

export const getGetSubscriptionStatusQueryOptions = <
  TData = Awaited<ReturnType<typeof getSubscriptionStatus>>,
  TError = HTTP401NotAuthenticatedErrorResponse | void,
>(options?: {
  query?: Partial<
    UseQueryOptions<
      Awaited<ReturnType<typeof getSubscriptionStatus>>,
      TError,
      TData
    >
  >;
  request?: SecondParameter<typeof customMutator>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetSubscriptionStatusQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getSubscriptionStatus>>
  > = ({ signal }) => getSubscriptionStatus({ signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getSubscriptionStatus>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetSubscriptionStatusQueryResult = NonNullable<
  Awaited<ReturnType<typeof getSubscriptionStatus>>
>;
export type GetSubscriptionStatusQueryError =
  HTTP401NotAuthenticatedErrorResponse | void;

export function useGetSubscriptionStatus<
  TData = Awaited<ReturnType<typeof getSubscriptionStatus>>,
  TError = HTTP401NotAuthenticatedErrorResponse | void,
>(
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getSubscriptionStatus>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getSubscriptionStatus>>,
          TError,
          Awaited<ReturnType<typeof getSubscriptionStatus>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customMutator>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetSubscriptionStatus<
  TData = Awaited<ReturnType<typeof getSubscriptionStatus>>,
  TError = HTTP401NotAuthenticatedErrorResponse | void,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getSubscriptionStatus>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getSubscriptionStatus>>,
          TError,
          Awaited<ReturnType<typeof getSubscriptionStatus>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customMutator>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetSubscriptionStatus<
  TData = Awaited<ReturnType<typeof getSubscriptionStatus>>,
  TError = HTTP401NotAuthenticatedErrorResponse | void,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getSubscriptionStatus>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customMutator>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Get subscription tier, current cost, and all tier costs
 */

export function useGetSubscriptionStatus<
  TData = Awaited<ReturnType<typeof getSubscriptionStatus>>,
  TError = HTTP401NotAuthenticatedErrorResponse | void,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getSubscriptionStatus>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customMutator>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetSubscriptionStatusQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

/**
 * @summary Get subscription tier, current cost, and all tier costs
 */
export const prefetchGetSubscriptionStatusQuery = async <
  TData = Awaited<ReturnType<typeof getSubscriptionStatus>>,
  TError = HTTP401NotAuthenticatedErrorResponse | void,
>(
  queryClient: QueryClient,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getSubscriptionStatus>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customMutator>;
  },
): Promise<QueryClient> => {
  const queryOptions = getGetSubscriptionStatusQueryOptions(options);

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
};

export type updateSubscriptionTierResponse200 = {
  data: SubscriptionStatusResponse;
  status: 200;
};

export type updateSubscriptionTierResponse401 = {
  data: HTTP401NotAuthenticatedErrorResponse;
  status: 401;
};

export type updateSubscriptionTierResponse422 = {
  data: HTTPValidationError;
  status: 422;
};

export type updateSubscriptionTierResponseSuccess =
  updateSubscriptionTierResponse200 & {
    headers: Headers;
  };
export type updateSubscriptionTierResponseError = (
  | updateSubscriptionTierResponse401
  | updateSubscriptionTierResponse422
) & {
  headers: Headers;
};

export type updateSubscriptionTierResponse =
  | updateSubscriptionTierResponseSuccess
  | updateSubscriptionTierResponseError;

export const getUpdateSubscriptionTierUrl = () => {
  return `/api/credits/subscription`;
};

/**
 * @summary Update subscription tier or start a Stripe Checkout session
 */
export const updateSubscriptionTier = async (
  subscriptionTierRequest: SubscriptionTierRequest,
  options?: RequestInit,
): Promise<updateSubscriptionTierResponse> => {
  return customMutator<updateSubscriptionTierResponse>(
    getUpdateSubscriptionTierUrl(),
    {
      ...options,
      method: "POST",
      headers: { "Content-Type": "application/json", ...options?.headers },
      body: JSON.stringify(subscriptionTierRequest),
    },
  );
};

export const getUpdateSubscriptionTierMutationOptions = <
  TError = HTTP401NotAuthenticatedErrorResponse | HTTPValidationError,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateSubscriptionTier>>,
    TError,
    { data: SubscriptionTierRequest },
    TContext
  >;
  request?: SecondParameter<typeof customMutator>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateSubscriptionTier>>,
  TError,
  { data: SubscriptionTierRequest },
  TContext
> => {
  const mutationKey = ["updateSubscriptionTier"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateSubscriptionTier>>,
    { data: SubscriptionTierRequest }
  > = (props) => {
    const { data } = props ?? {};

    return updateSubscriptionTier(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdateSubscriptionTierMutationResult = NonNullable<
  Awaited<ReturnType<typeof updateSubscriptionTier>>
>;
export type UpdateSubscriptionTierMutationBody = SubscriptionTierRequest;
export type UpdateSubscriptionTierMutationError =
  | HTTP401NotAuthenticatedErrorResponse
  | HTTPValidationError;

/**
 * @summary Update subscription tier or start a Stripe Checkout session
 */
export const useUpdateSubscriptionTier = <
  TError = HTTP401NotAuthenticatedErrorResponse | HTTPValidationError,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof updateSubscriptionTier>>,
      TError,
      { data: SubscriptionTierRequest },
      TContext
    >;
    request?: SecondParameter<typeof customMutator>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof updateSubscriptionTier>>,
  TError,
  { data: SubscriptionTierRequest },
  TContext
> => {
  return useMutation(
    getUpdateSubscriptionTierMutationOptions(options),
    queryClient,
  );
};
export type previewSubscriptionUpgradeResponse200 = {
  data: SubscriptionUpgradePreview;
  status: 200;
};

export type previewSubscriptionUpgradeResponse401 = {
  data: HTTP401NotAuthenticatedErrorResponse;
  status: 401;
};

export type previewSubscriptionUpgradeResponse422 = {
  data: HTTPValidationError;
  status: 422;
};

export type previewSubscriptionUpgradeResponseSuccess =
  previewSubscriptionUpgradeResponse200 & {
    headers: Headers;
  };
export type previewSubscriptionUpgradeResponseError = (
  | previewSubscriptionUpgradeResponse401
  | previewSubscriptionUpgradeResponse422
) & {
  headers: Headers;
};

export type previewSubscriptionUpgradeResponse =
  | previewSubscriptionUpgradeResponseSuccess
  | previewSubscriptionUpgradeResponseError;

export const getPreviewSubscriptionUpgradeUrl = () => {
  return `/api/credits/subscription/preview`;
};

/**
 * @summary Review the prorated charge for a paid Pro-to-Max upgrade
 */
export const previewSubscriptionUpgrade = async (
  subscriptionUpgradePreviewRequest: SubscriptionUpgradePreviewRequest,
  options?: RequestInit,
): Promise<previewSubscriptionUpgradeResponse> => {
  return customMutator<previewSubscriptionUpgradeResponse>(
    getPreviewSubscriptionUpgradeUrl(),
    {
      ...options,
      method: "POST",
      headers: { "Content-Type": "application/json", ...options?.headers },
      body: JSON.stringify(subscriptionUpgradePreviewRequest),
    },
  );
};

export const getPreviewSubscriptionUpgradeMutationOptions = <
  TError = HTTP401NotAuthenticatedErrorResponse | HTTPValidationError,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof previewSubscriptionUpgrade>>,
    TError,
    { data: SubscriptionUpgradePreviewRequest },
    TContext
  >;
  request?: SecondParameter<typeof customMutator>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof previewSubscriptionUpgrade>>,
  TError,
  { data: SubscriptionUpgradePreviewRequest },
  TContext
> => {
  const mutationKey = ["previewSubscriptionUpgrade"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof previewSubscriptionUpgrade>>,
    { data: SubscriptionUpgradePreviewRequest }
  > = (props) => {
    const { data } = props ?? {};

    return previewSubscriptionUpgrade(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PreviewSubscriptionUpgradeMutationResult = NonNullable<
  Awaited<ReturnType<typeof previewSubscriptionUpgrade>>
>;
export type PreviewSubscriptionUpgradeMutationBody =
  SubscriptionUpgradePreviewRequest;
export type PreviewSubscriptionUpgradeMutationError =
  | HTTP401NotAuthenticatedErrorResponse
  | HTTPValidationError;

/**
 * @summary Review the prorated charge for a paid Pro-to-Max upgrade
 */
export const usePreviewSubscriptionUpgrade = <
  TError = HTTP401NotAuthenticatedErrorResponse | HTTPValidationError,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof previewSubscriptionUpgrade>>,
      TError,
      { data: SubscriptionUpgradePreviewRequest },
      TContext
    >;
    request?: SecondParameter<typeof customMutator>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof previewSubscriptionUpgrade>>,
  TError,
  { data: SubscriptionUpgradePreviewRequest },
  TContext
> => {
  return useMutation(
    getPreviewSubscriptionUpgradeMutationOptions(options),
    queryClient,
  );
};
export type getV1GetCreditHistoryResponse200 = {
  data: TransactionHistory;
  status: 200;
};

export type getV1GetCreditHistoryResponse401 = {
  data: HTTP401NotAuthenticatedErrorResponse;
  status: 401;
};

export type getV1GetCreditHistoryResponse422 = {
  data: HTTPValidationError;
  status: 422;
};

export type getV1GetCreditHistoryResponseSuccess =
  getV1GetCreditHistoryResponse200 & {
    headers: Headers;
  };
export type getV1GetCreditHistoryResponseError = (
  | getV1GetCreditHistoryResponse401
  | getV1GetCreditHistoryResponse422
) & {
  headers: Headers;
};

export type getV1GetCreditHistoryResponse =
  | getV1GetCreditHistoryResponseSuccess
  | getV1GetCreditHistoryResponseError;

export const getGetV1GetCreditHistoryUrl = (
  params?: GetV1GetCreditHistoryParams,
) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? "null" : String(value));
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0
    ? `/api/credits/transactions?${stringifiedParams}`
    : `/api/credits/transactions`;
};

/**
 * @summary Get credit history
 */
export const getV1GetCreditHistory = async (
  params?: GetV1GetCreditHistoryParams,
  options?: RequestInit,
): Promise<getV1GetCreditHistoryResponse> => {
  return customMutator<getV1GetCreditHistoryResponse>(
    getGetV1GetCreditHistoryUrl(params),
    {
      ...options,
      method: "GET",
    },
  );
};

export const getGetV1GetCreditHistoryQueryKey = (
  params?: GetV1GetCreditHistoryParams,
) => {
  return [`/api/credits/transactions`, ...(params ? [params] : [])] as const;
};

export const getGetV1GetCreditHistoryQueryOptions = <
  TData = Awaited<ReturnType<typeof getV1GetCreditHistory>>,
  TError = HTTP401NotAuthenticatedErrorResponse | HTTPValidationError,
>(
  params?: GetV1GetCreditHistoryParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getV1GetCreditHistory>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customMutator>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetV1GetCreditHistoryQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getV1GetCreditHistory>>
  > = ({ signal }) =>
    getV1GetCreditHistory(params, { signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getV1GetCreditHistory>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetV1GetCreditHistoryQueryResult = NonNullable<
  Awaited<ReturnType<typeof getV1GetCreditHistory>>
>;
export type GetV1GetCreditHistoryQueryError =
  | HTTP401NotAuthenticatedErrorResponse
  | HTTPValidationError;

export function useGetV1GetCreditHistory<
  TData = Awaited<ReturnType<typeof getV1GetCreditHistory>>,
  TError = HTTP401NotAuthenticatedErrorResponse | HTTPValidationError,
>(
  params: undefined | GetV1GetCreditHistoryParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getV1GetCreditHistory>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getV1GetCreditHistory>>,
          TError,
          Awaited<ReturnType<typeof getV1GetCreditHistory>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customMutator>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetV1GetCreditHistory<
  TData = Awaited<ReturnType<typeof getV1GetCreditHistory>>,
  TError = HTTP401NotAuthenticatedErrorResponse | HTTPValidationError,
>(
  params?: GetV1GetCreditHistoryParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getV1GetCreditHistory>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getV1GetCreditHistory>>,
          TError,
          Awaited<ReturnType<typeof getV1GetCreditHistory>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customMutator>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetV1GetCreditHistory<
  TData = Awaited<ReturnType<typeof getV1GetCreditHistory>>,
  TError = HTTP401NotAuthenticatedErrorResponse | HTTPValidationError,
>(
  params?: GetV1GetCreditHistoryParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getV1GetCreditHistory>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customMutator>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Get credit history
 */

export function useGetV1GetCreditHistory<
  TData = Awaited<ReturnType<typeof getV1GetCreditHistory>>,
  TError = HTTP401NotAuthenticatedErrorResponse | HTTPValidationError,
>(
  params?: GetV1GetCreditHistoryParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getV1GetCreditHistory>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customMutator>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetV1GetCreditHistoryQueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

/**
 * @summary Get credit history
 */
export const prefetchGetV1GetCreditHistoryQuery = async <
  TData = Awaited<ReturnType<typeof getV1GetCreditHistory>>,
  TError = HTTP401NotAuthenticatedErrorResponse | HTTPValidationError,
>(
  queryClient: QueryClient,
  params?: GetV1GetCreditHistoryParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getV1GetCreditHistory>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customMutator>;
  },
): Promise<QueryClient> => {
  const queryOptions = getGetV1GetCreditHistoryQueryOptions(params, options);

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
};

export type postV1RefundCreditTransactionResponse200 = {
  data: number;
  status: 200;
};

export type postV1RefundCreditTransactionResponse401 = {
  data: HTTP401NotAuthenticatedErrorResponse;
  status: 401;
};

export type postV1RefundCreditTransactionResponse422 = {
  data: HTTPValidationError;
  status: 422;
};

export type postV1RefundCreditTransactionResponseSuccess =
  postV1RefundCreditTransactionResponse200 & {
    headers: Headers;
  };
export type postV1RefundCreditTransactionResponseError = (
  | postV1RefundCreditTransactionResponse401
  | postV1RefundCreditTransactionResponse422
) & {
  headers: Headers;
};

export type postV1RefundCreditTransactionResponse =
  | postV1RefundCreditTransactionResponseSuccess
  | postV1RefundCreditTransactionResponseError;

export const getPostV1RefundCreditTransactionUrl = (transactionKey: string) => {
  return `/api/credits/${transactionKey}/refund`;
};

/**
 * @summary Refund credit transaction
 */
export const postV1RefundCreditTransaction = async (
  transactionKey: string,
  postV1RefundCreditTransactionBody: PostV1RefundCreditTransactionBody,
  options?: RequestInit,
): Promise<postV1RefundCreditTransactionResponse> => {
  return customMutator<postV1RefundCreditTransactionResponse>(
    getPostV1RefundCreditTransactionUrl(transactionKey),
    {
      ...options,
      method: "POST",
      headers: { "Content-Type": "application/json", ...options?.headers },
      body: JSON.stringify(postV1RefundCreditTransactionBody),
    },
  );
};

export const getPostV1RefundCreditTransactionMutationOptions = <
  TError = HTTP401NotAuthenticatedErrorResponse | HTTPValidationError,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postV1RefundCreditTransaction>>,
    TError,
    { transactionKey: string; data: PostV1RefundCreditTransactionBody },
    TContext
  >;
  request?: SecondParameter<typeof customMutator>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postV1RefundCreditTransaction>>,
  TError,
  { transactionKey: string; data: PostV1RefundCreditTransactionBody },
  TContext
> => {
  const mutationKey = ["postV1RefundCreditTransaction"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postV1RefundCreditTransaction>>,
    { transactionKey: string; data: PostV1RefundCreditTransactionBody }
  > = (props) => {
    const { transactionKey, data } = props ?? {};

    return postV1RefundCreditTransaction(transactionKey, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostV1RefundCreditTransactionMutationResult = NonNullable<
  Awaited<ReturnType<typeof postV1RefundCreditTransaction>>
>;
export type PostV1RefundCreditTransactionMutationBody =
  PostV1RefundCreditTransactionBody;
export type PostV1RefundCreditTransactionMutationError =
  | HTTP401NotAuthenticatedErrorResponse
  | HTTPValidationError;

/**
 * @summary Refund credit transaction
 */
export const usePostV1RefundCreditTransaction = <
  TError = HTTP401NotAuthenticatedErrorResponse | HTTPValidationError,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postV1RefundCreditTransaction>>,
      TError,
      { transactionKey: string; data: PostV1RefundCreditTransactionBody },
      TContext
    >;
    request?: SecondParameter<typeof customMutator>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof postV1RefundCreditTransaction>>,
  TError,
  { transactionKey: string; data: PostV1RefundCreditTransactionBody },
  TContext
> => {
  return useMutation(
    getPostV1RefundCreditTransactionMutationOptions(options),
    queryClient,
  );
};
